export enum ErrorMessages {
    DELETE = "Es ist ein Fehler beim Löschvorgang aufgetreten",
    READ_UNREAD = "Es ist ein Fehler beim (Un)Gelesen setzten aufgetreten",
    REQUEST = "Es ist ein Fehler beim Abfragen der Daten aufgetreten",
    REQUEST_HILFE = "Es ist ein Fehler beim Abfragen der Hilfe aufgetreten",
}
